import { formatUSD } from "@/utils";
import { useState } from "react";

const MobileClientRow = ({ record, t }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="text-black relative py-4">
      {/* 小三角按钮 */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="absolute right-4 top-6 z-10 flex h-6 w-6 items-center justify-center"
      >
        <div
          className={`h-0 w-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent 
                border-r-transparent border-t-primary transition-transform duration-300 ${
                  expanded ? "rotate-180" : ""
                }`}
        />
      </button>
      {/* 顶部信息 */}
      <div className="flex flex-col">
        <span className="text-xl font-semibold">{record.name || "--"}</span>
        <span className="text-base font-semibold text-[#9ca3af]">
          {t("csr.uuid")}
          {record.uuid || "--"}
        </span>
      </div>

      {/* 折叠内容 */}
      {expanded && (
        <div className="text-black mt-4 rounded-xl bg-white p-4 text-sm">
          <div className="mb-2">
            <span className="mr-4 min-w-[72px] text-[#9ca3af]">{t("csr.client_investment_donation")}</span>
            <span>{formatUSD(record?.totalTradingDonationAmountUsd)} USD</span>
          </div>
          <div className="mb-2">
            <span className="mr-4 min-w-[72px] text-[#9ca3af]">{t("csr.client_dream_donation")}</span>
            <span>{formatUSD(record?.totalDreamPointsDonationAmountUsd)} USD</span>
          </div>
          <div>
            <span className="mr-4 min-w-[72px] text-[#9ca3af]">{t("csr.donation_total")}</span>
            <span>{formatUSD(record?.totalDonationAmountUsd)} USD</span>
          </div>
        </div>
      )}
    </div>
  );
};
export default MobileClientRow;
